import React from 'react';
import styles from './TopicsTagsSection.module.css';

interface TopicTagItem {
    name: string;
    count: number;
}

interface TopicsTagsSectionProps {
    topics: TopicTagItem[];
    tags: TopicTagItem[];
}

const TopicsTagsSection: React.FC<TopicsTagsSectionProps> = ({ topics, tags }) => {
    return (
        <div className={styles.topicsTagsContainer}>
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Любимые темы 🎯</h3>
                <p className={styles.sectionSubtitle}>О чём пишет наш автор</p>
                {topics.map((topic, index) => (
                    <div key={index} className={styles.topicItem}>
                        <span className={styles.topicName}>{topic.name}</span>
                        <span className={styles.topicCount}>{topic.count} публикаций</span>
                        <div className={styles.topicBar}>
                            <div
                                className={styles.topicBarFill}
                                style={{width: `${(topic.count / Math.max(...topics.map(t => t.count))) * 100}%`}}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>

            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Популярные теги 🏷️</h3>
                <p className={styles.sectionSubtitle}>Чаще всего использует</p>
                {tags.map((tag, index) => (
                    <div key={index} className={styles.tagItem}>
                        <span className={styles.tagName}>#{tag.name}</span>
                        <span className={styles.tagCount}>{tag.count} раз</span>
                        <div className={styles.tagPopularity}>
                            {"★".repeat(Math.ceil(tag.count / 5))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopicsTagsSection;